import { faMapMarkerAlt, faHeart, faSearch } from "@fortawesome/pro-light-svg-icons";

const FalIcons = [faMapMarkerAlt, faHeart, faSearch];

export default FalIcons;
